import { CrudPage } from '../../components/CrudPage';
import { type ShiftTemplateDto } from '../../api/models/ShiftTemplateDto';
import ShiftModelTemplateFormDialog from '../forms/ShiftModelTemplateFormDialog.tsx';
import { ShiftTemplateControllerService } from '../../api/services/ShiftTemplateControllerService';

// Type with required id for the CrudPage
type ShiftTemplateWithId = Omit<ShiftTemplateDto, 'id'> & { id: string };

const ShiftModelTemplatesPage = () => {
  // Helper function to convert ShiftTemplateDto[] to ShiftTemplateWithId[]
  const fetchData = async (): Promise<ShiftTemplateWithId[]> => {
    const data = await ShiftTemplateControllerService.findAll();
    return data.map(item => ({
      ...item,
      id: item.uuid || ''
    }));
  };

  return (
    <CrudPage<ShiftTemplateWithId>
      titleKey="headers.shiftModelTemplates"
      gridMeta={[
        { field: 'name', headerKey: 'shiftModelTemplate.grid.field.name', width: 150 },
        { field: 'description', headerKey: 'shiftModelTemplate.grid.field.description', width: 200 },
        { field: 'entries', headerKey: 'shiftModelTemplate.grid.field.entries', width: 100, 
          render: (data: any) => data.entries?.length || 0 }
      ]}
      fetchData={fetchData}
      saveData={async (data: ShiftTemplateWithId) => {
        // Convert back to ShiftTemplateDto format
        const apiData: ShiftTemplateDto = {
          ...data,
          uuid: data.id // id is the uuid in our internal type
        };
        
        if (data.id) {
          await ShiftTemplateControllerService.update(data.id, apiData);
        } else {
          await ShiftTemplateControllerService.create(apiData);
        }
      }}
      deleteData={(id: string) => ShiftTemplateControllerService.delete(id)}
      FormComponent={ShiftModelTemplateFormDialog}
      entityName="shifttemplate"
    />
  );
};

export default ShiftModelTemplatesPage;
